import React from 'react'
import PropTypes from 'prop-types'

import {
  CheckboxContainer,
  HiddenCheckbox,
  StyledCheckbox,
  CheckBoxLabel,
  LabelSpan,
  CheckMarkIcon,
  DashMarkIcon,
  SelectAllIcon,
} from './styles'

import colors from '@settings/styleSettings'

import 'material-icons/iconfont/outlined.css'

const CheckBoxContainer = ({
  checked,
  locked,
  isInaccessible,
  onChange,
  label,
  state,
  disabled,
}) => {
  const defineBackGround = () => {
    if (locked) return colors.strongGray
    if (checked) return colors.primary
    return colors.background
  }

  const onHandleChange = () => {
    if (!locked) onChange(!checked)
  }

  return (
    <CheckBoxLabel state={state}>
      <CheckboxContainer>
        <HiddenCheckbox checked={checked} onChange={onHandleChange} disabled={disabled} />
        <StyledCheckbox
          checked={checked}
          locked={locked}
          state={state}
          background={defineBackGround()}
        >
          {(isInaccessible && <DashMarkIcon className="material-icons-outlined">remove</DashMarkIcon>)
            || (state ? <SelectAllIcon className="material-icons-outlined">indeterminate_check_box</SelectAllIcon>
              : <CheckMarkIcon className="material-icons-outlined">done</CheckMarkIcon>)}
        </StyledCheckbox>
      </CheckboxContainer>
      <LabelSpan>{label}</LabelSpan>
    </CheckBoxLabel>
  )
}

CheckBoxContainer.propTypes = {
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  locked: PropTypes.bool,
  isInaccessible: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  state: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
}

CheckBoxContainer.defaultProps = {
  checked: undefined,
  locked: undefined,
  isInaccessible: undefined,
  label: '',
  disabled: false,
  state: undefined,
}

export default CheckBoxContainer
